import { homeLoanSchema } from '__core/shared/model/homeLoan/HomeLoan.schema';
import {
  assetFinanceSchema as objectiveAFSchema,
  homeLoanSchema as objectiveHLSchema
} from '__core/shared/model/finance/Objective.schema';

/* @ngInject */

export default () => {
  const config = (data) => ({
    abortEarly: false,
    allowUnknown: false,
    stripUnknown: true,
    ...(data.context && { context: data.context })
  });
  const assert = (data, path, schema, errors, messages) => {
    let newErrors = errors || [];
    let newMessages = messages || [];
    try {
      joi.assert(_.get(data, path) || null, schema, config(data));
    } catch (err) {
      if (err?.isJoi) {
        newErrors = _.compact(_.union(newErrors, err.details));
        newMessages = _.uniq(_.compact(_.union(newMessages, _.map(err.details, 'message'))));
      }
    }
    return { errors: newErrors, messages: newMessages };
  };
  const validate = (data) => {
    let errors = [];
    let messages = [];

    try {
      if (data?.ticket?.objectives) {
        ({ errors, messages } = assert(
          data?.ticket,
          'objectives',
          data?.type === 'af' ? objectiveAFSchema(joi) : objectiveHLSchema(joi),
          errors,
          messages
        ));
      }

      if (data?.type === 'hl' && data?.homeLoan) {
        ({ errors, messages } = assert(
          data,
          'homeLoan',
          homeLoanSchema(joi, ' '),
          errors,
          messages
        ));
      }
    } catch (ignore) {
      // Do not throw errors, just skip validation
    }

    return {
      validationErrors: errors,
      validationMessages: _.uniq(messages)
    };
  };

  return {
    config,
    assert,
    validate
  };
};
